module.exports = __webpack_public_path__ + "img/i_phonefee_op_video.2b154db7.svg";